const MEMBER_BASE_URL = "https://member.davm.co.id";
const REFERRAL_COOKIE = "davm_locked_referral";

export function getReferralCode() {
  const params = new URLSearchParams(window.location.search);
  const fromUrl = params.get("ref");
  if (fromUrl) {
    return fromUrl.trim().toUpperCase();
  }

  const cookies = document.cookie.split(";");
  for (const cookie of cookies) {
    const [name, ...rest] = cookie.trim().split("=");
    if (name === REFERRAL_COOKIE) {
      return decodeURIComponent(rest.join("=")).trim().toUpperCase();
    }
  }

  return null;
}

export function buildMemberUrl(path = "") {
  const normalizedPath = path.startsWith("/") ? path : path ? `/${path}` : "";
  let url = `${MEMBER_BASE_URL}${normalizedPath}`;
  const ref = getReferralCode();

  if (ref) {
    url += `${url.includes("?") ? "&" : "?"}ref=${encodeURIComponent(ref)}`;
  }

  return url;
}

export const memberAreaUrl = () => buildMemberUrl("");
export const memberRegisterUrl = () => buildMemberUrl("/register");
